<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect,
  },
  data() {
    return {
      errorMessage: "",
      title: "API Airline Search Routing Create",
      items: [
        {
          text: "Airline Routing",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      vendors: [],
      airlines: [],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
        is_allowed: "",
        api_vendor_id: "",
        origin: "",
        destination: "",
        airline_code: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      is_allowed: {
        required,
      },
      api_vendor_id: {
        required,
      },
        origin: {
            required,
        },
        destination: {
            required,
        },
      airline_code: {
        required,
        minLength: minLength(2),
      },
    },
  },
  mounted() {
    this.getVendorList();
    this.getAirlineList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async getAirlineList() {
      try {
        axios
          .get("/api/airline/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                var temp=response.data.data;
                var i;
                for (i=0;i<temp.length;i++){
                    temp[i].value=temp[i].code;
                    temp[i].text=temp[i].name+' ('+temp[i].code+')';
                }
                this.airlines = temp;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getVendorList() {
      try {
        axios
          .get("/api/vendor/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.vendors = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },

    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/airline/route_create", {
          is_allowed: this.form.is_allowed,
          api_vendor_id: this.form.api_vendor_id,
          airline_code: this.form.airline_code,
          origin: this.form.origin,
          destination: this.form.destination,
          created_by: localStorage.getItem("id"),
          updated_by: localStorage.getItem("id"),
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.airlineRoutingForm.reset();
            this.$swal("Good job!", "Airline Route Created", "success");
            this.$router.push({ name: "route_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="airlineRoutingForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="is_allowed">Allowed</label>
                    <select
                      id="is_allowed"
                      name="is_allowed"
                      v-model="form.is_allowed"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.form.is_allowed.$error }">
                        <option value="" disabled style="display:none" selected>Select Allowed</option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.is_allowed.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.is_allowed.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="api_vendor_id ">API Vendor ID</label>
                    <select
                      id="api_vendor_id "
                      name="api_vendor_id "
                      v-model="form.api_vendor_id "
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.form.api_vendor_id .$error }">
                        <option value="" disabled style="display:none" selected>Select Api Vendor Id</option>
                      <option v-for="(vendor, index) in vendors" :value="vendor.id" v-if="vendor.is_active == 1"
                            v-bind:key="index">{{ vendor.api_provider }}
                    </option>
                    </select>
                    <div
                      v-if="submitted && $v.form.api_vendor_id .$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.api_vendor_id .required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="origin">Origin</label>
                    <input
                      id="origin"
                      v-model="form.origin"
                      name="origin"
                      type="text"
                      class="form-control"
                      placeholder="Type origin name"
                      value
                      :class="{ 'is-invalid1': submitted && $v.form.origin.$error }"
                    />
<!--                    <div-->
<!--                      v-if="submitted && $v.form.origin.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.origin.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="destination">Destination</label>
                    <input
                      id="destination"
                      v-model="form.destination"
                      name="destination"
                      type="text"
                      class="form-control"
                      placeholder="Type Destination "
                      value
                      :class="{ 'is-invalid1': submitted && $v.form.destination.$error }"
                    />
<!--                    <div-->
<!--                      v-if="submitted && $v.form.destination.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.destination.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="required" for="airline_code">Airline Code</label>
                      <model-select :options="airlines"
                                    v-model="form.airline_code"
                                    :class="{ 'is-invalid': submitted && $v.form.airline_code.$error}"
                                    placeholder="Select Airline">
                      </model-select>
                    <div
                      v-if="submitted && $v.form.airline_code.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.airline_code.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
